/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyAttachmentViewModel } from "../types/AssociatedCompanyAttachmentViewModel.ts";

export const associatedCompanyAttachmentViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  attachmentFileName: z.string().nullish(),
  attachmentUrl: z.string().nullish(),
}) as unknown as ToZod<AssociatedCompanyAttachmentViewModel>;
